import { render, staticRenderFns } from "./CustomFullCalendar.vue?vue&type=template&id=0fc4d7f2&"
import script from "./CustomFullCalendar.vue?vue&type=script&lang=js&"
export * from "./CustomFullCalendar.vue?vue&type=script&lang=js&"
import style0 from "./CustomFullCalendar.vue?vue&type=style&index=0&id=0fc4d7f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports